import ImageGalleryUploaderWidget from 'forms/components/ImageGalleryUploaderWidget';
import ReceiptPrinterSettingsWidget from 'forms/components/ReceiptPrinterSettingsWidget';

const uiSchema = {
  'facilitySettings': {
    'dba': { 'ui:width': '50%' },
    'govQualifiedPrice': { 'ui:width': '50%' },
    'lunchStartTime': { 'ui:width': '25%' },
    'lunchEndTime': { 'ui:width': '25%' },
    'dinnerStartTime': { 'ui:width': '25%' },
    'dinnerEndTime': { 'ui:width': '25%' },
    'deliverySetting': {
      'canStartDeliveryBefore': { 'ui:width': '25%' },
      'canStartDeliveryAfter': { 'ui:width': '25%' },
      'canCompleteOrderAfter': { 'ui:width': '25%' },
      'canModifyDiaryAfter': { 'ui:width': '25%' },
    },
    'qrCodeSettings': {
      'documentTitleImageS3Keys': { 'ui:widget': ImageGalleryUploaderWidget },
    },
    'receiptPrinterSettings': {
      'ui:field': ReceiptPrinterSettingsWidget,
    },
    'receiptInfo': {
      'receiptType': { 'ui:width': '33.33%' },
      'taxIdNumber': { 'ui:width': '33.33%' },
      'faxNumber': { 'ui:width': '33.33%' },
      'bankName': { 'ui:width': '33.33%' },
      'accountNumber': { 'ui:width': '33.33%' },
      'accountName': { 'ui:width': '33.33%' },
      'bankName2': { 'ui:width': '33.33%' },
      'accountNumber2': { 'ui:width': '33.33%' },
      'accountName2': { 'ui:width': '33.33%' },
      'bankName3': { 'ui:width': '33.33%' },
      'accountNumber3': { 'ui:width': '33.33%' },
      'accountName3': { 'ui:width': '33.33%' },
      'chairmanName': { 'ui:width': '33.33%' },
      'accountantName': { 'ui:width': '33.33%' },
      'handlerName': { 'ui:width': '33.33%' },
      'managerTitle': { 'ui:width': '33.33%' },
      'reverseCopyType': { 'ui:width': '33.33%' },
      'oneCopyOneSheet': { 'ui:width': '33.33%' },
      'maskIdentificationCardId': { 'ui:width': '33.33%' },
      'hideIdentificationCardId': { 'ui:width': '33.33%' },
      'hideCaseNumber': { 'ui:width': '33.33%' },
      'hideCmsLevel': { 'ui:width': '33.33%' },
      'hideAccountant': { 'ui:width': '33.33%' },
    },
    'receiptSettings': {
      'originalPrice': { 'ui:width': '20%' },
      'copaymentSettings': {
        'items': {
          'disadvantagedType': { 'ui:width': '30%' },
          'disadvantagedLabel': { 'ui:width': '50%' },
          'copayment': { 'ui:width': '20%' },
          'ui:title': '',
        },
        'ui:options': {
          'orderable': false,
        },
      },
    },
  },
  'onlinePaymentSettings': {
    'newebPaySettings': {
      'merchantId': { 'ui:width': '50%' },
      'hashKey': { 'ui:width': '50%' },
      'hashIV': { 'ui:width': '50%' },
      'env': { 'ui:width': '50%' },
    },
    'linePaySettings': {
      'channelId': { 'ui:width': '50%' },
      'channelSecretKey': { 'ui:width': '50%' },
      'env': { 'ui:width': '50%' },
    },
    'givemeSettings': {
      'idno': { 'ui:width': '50%' },
      'password': { 'ui:width': '50%' },
      'uncode': { 'ui:width': '50%' },
      'donationRecipient': { 'ui:width': '50%' },
      'donationCode': { 'ui:width': '50%' },
      'env': { 'ui:width': '50%' },
    },
  },
};

export default uiSchema;
